var CSSCONSTANTS = CSSCONSTANTS || {};

(function (factory) {
    if (typeof define === 'function' && define.amd) {
        define(function (require) {
            factory(require('jquery'));
        });
    } else {
        factory(window.jQuery);
    }
})(function () {

    /* used by globalHeaderActions.js and headerMessages.js */
    CSSCONSTANTS.globalHeaderSecondaryClass = 'global-header__secondary';

    /* used by globalHeaderActions.js */
    CSSCONSTANTS.globalHeaderActionsClass = 'global-header__actions';
    CSSCONSTANTS.globalHeaderActionsActionClass = 'global-header__actions__action';
    CSSCONSTANTS.globalHeaderActionsActionTwoClass = 'global-header__actions__action--two';
    CSSCONSTANTS.globalHeaderActionsLoginClass = 'global-header__actions__login';
    CSSCONSTANTS.globalHeaderActionsRetrieveClass = 'global-header__actions__retrieve';
    CSSCONSTANTS.globalHeaderActionsWelcomeClass = 'global-header__actions__welcome';
    CSSCONSTANTS.globalHeaderActionsWelcomeSalutationClass = 'global-header__actions__welcome__salutation';

    /* used by globalNav.js */
    CSSCONSTANTS.globalNavCategoriesClass = 'global-nav__categories';
    CSSCONSTANTS.globalNavCategoryOpenClass = 'show-contents';
    CSSCONSTANTS.globalNavSubCategoriesClass = 'global-nav__subcategories';
    CSSCONSTANTS.globalNavSubCategoriesCloseClass = 'global-nav__subcategories__close';
    CSSCONSTANTS.globalNavPromoClass = 'global-nav__promo';
    CSSCONSTANTS.skipNavLinkClass = 'skip-nav-link';
    CSSCONSTANTS.mainId = 'main';
    CSSCONSTANTS.globalNavCategoryLinkWithSubCategoriesClass = 'global-nav__category__link--with-subcategories';

    /* used by globalNav.js and mobileNav.js */
    CSSCONSTANTS.globalNavCategoryClass = 'global-nav__category';

    /* used by globalHeaderActions.js and mobileNav.js */
    CSSCONSTANTS.globalHeaderMastheadClass = 'global-header__masthead';
    CSSCONSTANTS.globalNavCategoryLinkClass = 'global-nav__category__link';
    CSSCONSTANTS.globalNavSubCategoryClass = 'global-nav__subcategory';

    /* used by mobileNav.js */
    CSSCONSTANTS.pageClass = 'page';
    CSSCONSTANTS.globalSearchClass = 'global-search';
    CSSCONSTANTS.globalHeaderSearchFormClass = 'global-header__search__form';
    CSSCONSTANTS.mobileNavClass = 'mobile-nav';
    CSSCONSTANTS.mobileNavOpenClass = 'mobile-nav-open';
    CSSCONSTANTS.mobileNavCategoriesClass = 'mobile-nav__categories';
    CSSCONSTANTS.mobileNavCategoryClass = 'mobile-nav__category';
    CSSCONSTANTS.mobileNavCategoryHelpClass = 'mobile-nav__category--help';
    CSSCONSTANTS.mobileNavCategoryLinkClass = 'mobile-nav__category__link';
    CSSCONSTANTS.mobileNavCategoryLinkHelpClass = 'mobile-nav__category__link--help';
    CSSCONSTANTS.mobileNavSubCategoriesClass = 'mobile-nav__subcategories';
    CSSCONSTANTS.mobileNavSubCategoriesOpenClass = 'mobile-nav__subcategories--open';
    CSSCONSTANTS.mobileNavSubCategoriesContainerClass = 'mobile-nav__subcategories__container';
    CSSCONSTANTS.mobileNavSubCategoriesHeadingClass = 'mobile-nav__subcategories__heading';
    CSSCONSTANTS.mobileNavSearchFormClass = 'mobile-nav__search-form';
    CSSCONSTANTS.globalNavHelpClass = 'global-nav__help';
    CSSCONSTANTS.mobileNavToggleClass = 'mobile-nav-toggle';
    CSSCONSTANTS.globalNavSubcategoryHeaderClass = 'global-nav__subcategory__header';
    CSSCONSTANTS.mobileNavSubcategoryHeadingClass = 'mobile-nav__subcategory__heading';
    CSSCONSTANTS.mobileNavSubcategoryContentsClass = 'mobile-nav__subcategory__contents';
    CSSCONSTANTS.globalNavSubcategoryContentsClass = 'global-nav__subcategory__contents';
    CSSCONSTANTS.globalNavSubcategoryContentsProminentClass = 'global-nav__subcategory__contents--prominent';
    CSSCONSTANTS.globalNavSubcategoryContentsItemClass = 'global-nav__subcategory__contents__item';
    CSSCONSTANTS.mobileNavSubcategoryContentsItemClass = 'mobile-nav__subcategory__contents__item';
    CSSCONSTANTS.mobileNavCloseClass = 'mobile-nav__close';

    /* used by globalSearch.js */
    CSSCONSTANTS.globalHeaderSearchClass = 'global-header__search';
    CSSCONSTANTS.globalNavSearchClass = 'global-nav__search';
    CSSCONSTANTS.globalNavSearchOpenClass = 'global-nav__search--open';
    CSSCONSTANTS.globalSearchButtonClass = 'global-search__button';

    /* used by headerMessages.js */
    CSSCONSTANTS.globalHeaderMessagesToggleClass = 'global-header__messages-toggle';
    CSSCONSTANTS.globalHeaderMessagesPanelClass = 'global-header__messages-panel';
    CSSCONSTANTS.globalHeaderClass = 'global-header';
    CSSCONSTANTS.globalHeaderLogoClass = 'global-header__confused-logo';
    CSSCONSTANTS.globalNavToolsClass = 'global-nav__tools';
    CSSCONSTANTS.globalHeaderMessagesPanelCloseClass = 'global-header__messages-panel__close';
    CSSCONSTANTS.globalHeaderMessagesToggleClosedClass = 'global-header__messages-toggle--closed';
    CSSCONSTANTS.globalHeaderMessagesToggleOpenedClass = 'global-header__messages-toggle--open';
    CSSCONSTANTS.globalHeaderMessagesToggleViewedClass = 'global-header__messages-toggle--viewed';
});